import { Router } from '@angular/router';
import { AppComponent } from '../../app.component';
import { NgxSpinnerService } from 'ngx-spinner';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { ServicioAlertas } from './ServicioAlertas';
import { Table } from 'primeng/table';

export class Util {

    private static spinner: NgxSpinnerService

    /**
     * 
     * @param router
     * @param path
     */
    public static forward(router: Router, path: string): void {
        router.navigate(['/' + path]);
         //this._router.navigate(['PortadaInicioComponent'], { queryParams: { avisar: '1' } });
    }

    /**
     * 
     */
    public static getDateSpanish(): any {

        let es: any;

        es = {
            firstDayOfWeek: 1,
            dayNames: ["Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"],
            dayNamesShort: ["Dom", "Lun", "Mar", "Mié", "Jue", "Vie", "Sáb"],
            dayNamesMin: ["Dom", "Lun", "Mar", "Mié", "Jue", "Vie", "Sáb"],
            monthNames: ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"],
            monthNamesShort: ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"],
            today: 'Hoy',
            clear: 'Borrar'
        }

        return es;
    }


    /**
     * 
     * @param spinner
     * @param message
     */
    public static showLoadingMessage(spinner: NgxSpinnerService, message: string) {
        AppComponent.message = message;
        Util.spinner = spinner;
        Util.spinner.show();
    }

    /**
     * 
     */
    public static hideLoadingMessage() {
        Util.spinner.hide();
    }

    /**
     * 
     * @param date
     * @param days
     */
    public static addDays(date: Date, days: number): Date {
        let object = JSON.stringify(date);
        let _date: Date = new Date(JSON.parse(object));
        _date.setDate(_date.getDate() + days);
        return _date;
    }

    /**
     * 
     * @param obj
     */
    public static clone<T>(obj: any): T {
        let json = JSON.stringify(obj);
        return JSON.parse(json);
    }

    /**
     * 
     * @param servicioAlertas
     * @param titulo
     * @param mensaje
     * @param tipoMensaje
     * @param html
     * @param forward
     */
    public static showMessage(servicioAlertas: ServicioAlertas, titulo: string, mensaje: string, tipoMensaje: string, html: boolean = false, callback:() => any = null): void {

        if (html == false) {

            servicioAlertas.mostrarConOpciones({
                title: `${titulo}`,
                text: `${mensaje}`,
                icon: `${tipoMensaje}`,
                showCancelButton: false,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Aceptar',
                cancelButtonText: 'Cancelar'
            }).then((result) => {

                console.log('result.value -->> ', result.value)

                if (result.value) {

                } else {

                    if (result.dismiss === Swal.DismissReason.cancel) {

                    }

                    if (result.dismiss === Swal.DismissReason.backdrop) {

                    }
                }

                if (callback != null) {
                    callback.call(1);
                }

            });

        } else {

            servicioAlertas.mostrarConOpciones({
                title: `${titulo}`,
                html: `${mensaje}`,
                icon: `${tipoMensaje}`,
                showCancelButton: false,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Aceptar',
                cancelButtonText: 'Cancelar'
            }).then((result) => {

                console.log('result.value -->> ', result.value)

                if (result.value) {

                } else {

                    if (result.dismiss === Swal.DismissReason.cancel) {

                    }

                    if (result.dismiss === Swal.DismissReason.backdrop) {

                    }
                }

                if (callback != null) {
                    callback.call(1);
                }

            });

        }

    }

    /**
     * 
     * @param table
     * @param index
     */
    public static onRowSelect(table: Table, index: number): void {

        if (table != null) {

            table.reset();

            let lista: any = Util.clone(table.value);

            table.value = lista;

            table.selection = table.value[index - 1];
        }

    }

}